import { createSlice } from "@reduxjs/toolkit";

const initState = {
  questions: [],
};

export const questionsSlice = createSlice({
  name: "questions",
  initialState: initState,
  reducers: {
    setQuestionsReducer: (state, action) => {
      let tempObj = { ...state, ...action.payload };
      return tempObj;
    },
    resetQuestionsReducer: () => initState,
  },
});

export const { setQuestionsReducer, resetQuestionsReducer } =
  questionsSlice.actions;

export default questionsSlice.reducer;
